import angular from 'angular';

class ContactController {
  /* @ngInject */
  constructor($rootScope) {
    const vm = this;

    vm.$onInit = () => {
      $rootScope.pageTitle = 'Contact';
      // $rootScope.pageDescription = '';

      angular.extend(vm, vm.contact.fields);
    };
  }
}

export default ContactController;
